import React, {useEffect, useState} from 'react';
import {Search} from 'react-feather';
import LogoAvatar from '../Item/LogoAvatar';
import {getBrokerFilterVendors} from '../../services/api/messaging';
import {from, BehaviorSubject} from 'rxjs';
import {
    filter,
    debounceTime,
    distinctUntilChanged,
    switchMap,
} from 'rxjs/operators';
import LoadSpinner from "../Common/LoadSpinner";
import {getAdminFilterVendors} from "../../services/api/admin";

let searchSubject = new BehaviorSubject('');
let searchResultObservable = searchSubject.pipe(
    filter((val) => val.length > 2),
    debounceTime(1250),
    distinctUntilChanged(),
    switchMap((val) => from(getBrokerFilterVendors(val))),
);

let adminSearchResultObservable = searchSubject.pipe(
    filter((val) => val.length > 2),
    debounceTime(1250),
    distinctUntilChanged(),
    switchMap((val) => from(getAdminFilterVendors(val))),
);


const useObservable = (observable, setter, setterLoad) => {
    useEffect(() => {
        let subscription = observable.subscribe((results) => {
            setter(results);
            setterLoad(false);
        });

        return () => subscription.unsubscribe();
    }, [observable, setter, setterLoad]);
};

const VendorSearch = ({onVendorSelect, isAdmin, hasError = false}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResultVendors, setSearchResultVendors] = useState([]);
    const [loading, setLoading] = useState(false);

    useObservable(isAdmin ? adminSearchResultObservable : searchResultObservable, setSearchResultVendors, setLoading);

    useEffect(() => {
        return () => {
            searchSubject.next('');
        };
    }, [searchTerm]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        setLoading(value.length > 2);
        setSearchResultVendors([]);
        searchSubject.next(value);
    };

    const vendorSelect = (vendor) => {
        onVendorSelect(vendor);

        setSearchTerm('');
        setSearchResultVendors([]);
        setLoading(false);
    };

    return (
        <div className="sl-flex sl-flex-col sl-gap-2 sl-align-stretch">
            <div
                className={`sl-input sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-flex
                ${hasError ? 'sl-border-1 sl-border-solid sl-border-error-300 ' : ''}`}>
                <Search className="sl-icon sl-icon-leading sl-place-self-center sl-h-5 sl-w-5 sl-ml-2"/>
                <input
                    value={searchTerm}
                    onChange={handleInputChange}
                    className="sl-input sl-border-none sl-font sl-text-md sl-font sl-font-normal sl-text-md sl-p-0 sl-m-0 sl-h-11 sl-w-fill-available"
                    type="text"
                    placeholder="Search"
                />
            </div>

            {searchResultVendors?.length > 0 &&
            <div
                className="sl-flex sl-shadow-lg sl-rounded-lg sl-flex-col sl-gap-0 sl-mb-6 sl-text-gray-900 sl-text-md sl-h-auto sl-max-h-80 sl-overflow-y-scroll sl-customized-scrollbar">
                {searchResultVendors.map((vendor, index) => (
                    <div
                        key={index}
                        rel={vendor.id}
                        className="sl-cursor-pointer sl-flex sl-justify-flex-start sl-align-center sl-gap-2 sl-py-10 sl-px-14"
                        onClick={() => vendorSelect(vendor)}
                    >
                        <LogoAvatar slug={vendor.slug} logo={vendor.favico} avatarClass="sl-h-6 sl-w-6"/>
                        {vendor.name}
                    </div>
                ))}
                {(searchResultVendors.length === 0 && searchTerm.length > 2) && !loading && <div
                    className="sl-cursor-pointer sl-flex sl-justify-center sl-align-center sl-gap-2 sl-py-10 sl-px-14">
                    <div className="sl-font-medium sl-text-lg sl-text-gray-700">Nothing found...</div>
                </div>}
            </div>}

            {loading && <LoadSpinner/>}
        </div>
    );
};

export default VendorSearch;
